/**
 * DealScreenDetail — Deal screen detail route page
 * Authority: DEAL_EVALUATOR_PAGE_SPEC.md
 *
 * Route: /agents/deal-evaluator/:startup_id
 * Delegates all rendering to DealScreenDetailView.
 */

import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import DealScreenDetailView from '@/components/agents/deal-screen/DealScreenDetailView';
import { ROUTES } from '@/config/product-contract';

export default function DealScreenDetail() {
  const { startup_id } = useParams();
  const navigate = useNavigate();

  return (
    <DealScreenDetailView
      startupId={startup_id}
      onBack={() => navigate(ROUTES.DEAL_EVALUATOR)}
    />
  );
}
